import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "environments/environment";
import {CreateMenuBackup, GecoPosMenu, GetMenuRequest, MenuBackup} from "app/models/menu.model";
import {firstValueFrom} from "rxjs";
import {IBaseResponse} from "app/models/baseResponse.model";

@Injectable({
  providedIn: 'root'
})
export class MenuBackupService {
  private requestPath = `${environment.posBaseUrl}/api/front/menu-backup`;
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(private http: HttpClient) { }

  async getMenuBackups(organizationId: string): Promise<MenuBackup[]>{
    try{
      var response = await firstValueFrom((
        this.http.get<IBaseResponse<MenuBackup[]>>(this.requestPath+"/list/"+organizationId)
      ));
      return response.data;
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  async createBackup(request: CreateMenuBackup): Promise<MenuBackup>{
    try{
      var response = await firstValueFrom((
        this.http.post<IBaseResponse<MenuBackup>>(this.requestPath+"/backup",
          request,
          {
            headers: this.headers,
          },
      )));
      return response.data;
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  async deleteBackup(backupId: string): Promise<any> {
    try{
      return await firstValueFrom((
        this.http.delete(this.requestPath+"/"+backupId)
      ));
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  async downloadMenu(backupId: string) : Promise<string>{
    try{
      var response = await firstValueFrom((
        this.http.get<IBaseResponse<string>>(this.requestPath+"/"+backupId)));
      return response.data;
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  async getMenuSectionOrBackup(request: GetMenuRequest) : Promise<GecoPosMenu>{
    try{

      const headers: HttpHeaders = new HttpHeaders({
        'Content-Type': 'application/json',
        'x-api-key': 'r6t23TUmo4jByVc65UXrjRZvvz2Qbupu',
      });

      var response = await firstValueFrom((
        this.http.post<GecoPosMenu>(environment.posBaseUrl+"/api/v1/menu",
          request,
          {headers: headers,})));
      return response;
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }
}
